
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M256,0C140.77-.42,47,92.64,46.59,207.87V346.5a70,70,0,0,0,70,70H186a.13.13,0,0,0,.13-.13V230.53a.13.13,0,0,0-.13-.13H93.31a.12.12,0,0,1-.12-.13V211.2c0-94.16,78.87-170.08,172.86-164.44a163,163,0,0,1,153,162.65v20.86a.13.13,0,0,1-.13.13H326a.13.13,0,0,0-.13.13V416.38a.13.13,0,0,0,.13.13h92.92a.13.13,0,0,1,.13.13v48.64a.13.13,0,0,1-.13.13H256.13a.13.13,0,0,0-.13.13v46.33a.13.13,0,0,0,.13.13H430.41a35,35,0,0,0,35-35V442.11h0V209.41C465.55,93.9,372,.14,256.51,0Z","fill":"#fff"}})])
      }
    
      }
    